import { CircularProgressProps, LinearProgressProps } from '@mui/material';
import { BoxComponent } from './BoxComponent';
import CircularProgressComponent from './CircularProgressComponent';
import LinearProgressComponent from './LinearProgressComponent';
export type ProgressType = {
  type?: 'circle' | 'linear';
  progressProps?: CircularProgressProps | LinearProgressProps;
};

const ProgressBar: React.FC<ProgressType> = ({ type, progressProps }) => {
  return (
    <BoxComponent sx={{ width: '100%' }}>
      {type && type === 'circle' ? (
        <CircularProgressComponent {...(progressProps as CircularProgressProps)} />
      ) : (
        <LinearProgressComponent {...(progressProps as LinearProgressProps)} />
      )}
    </BoxComponent>
  );
};

export default ProgressBar;
